
// import React from "react";
// import guruImage from "../assets/assets/Picture1.jpg";
// import Navbar from "./Header";
// import Footer from "./Footer";
// import sukhadev from "../assets/assets/sukhadev.png";
// import pooja from "../assets/assets/pooja.jpg";
// import Girija from "../assets/assets/Girija.jpg";
// import Vaishali from "../assets/assets/Vaishali.jpg";
// import Shrutika  from "../assets/assets/Shrutika.jpg";
// import Prerana from "../assets/assets/Prerana.jpg";
// import Jayashree from "../assets/assets/Jayashree.jpg";
// import Rahul  from "../assets/assets/Rahul.jpg";
// import Ujwala from "../assets/assets/Ujwala.jpg";
// import Sheetal from "../assets/assets/Sheetal.jpg";
// import Shilpa from "../assets/assets/Shilpa.jpg";
// import Sharali from "../assets/assets/Sharali.jpg";
// import Sameena from "../assets/assets/Sameena.jpg";
// import Akanksha from "../assets/assets/Akanksha.jpg";
// import Poonam from "../assets/assets/Poonam.jpg";
// import Akshata from "../assets/assets/Akshata.jpg";
// import Rachana from "../assets/assets/Rachana.jpg";
// import Shrushti from "../assets/assets/Shrushti.jpg";
// import Divya from "../assets/assets/Divya.jpg";
// import Pradnya from "../assets/assets/Pradnya.jpg";
// import Shubhangi from "../assets/assets/Shubhangi.jpg";
// import Nikita from "../assets/assets/Nikita.jpg";
// import Ankita from "../assets/assets/Ankita.jpg";
// import Arpita from "../assets/assets/Arpita.jpg";
// const AboutUs = () => {

//   const faculties = [
//   { name: "Mr. Sukhadev S Koli", qualification: "DSCE, BCA, MCSE", role: "Manager & IT Head",image: sukhadev, },
//   { name: "Miss. Pooja S Kore", qualification: "B. Sc. B. Ed.", role: "Science Dept",image:pooja },
//   { name: "Miss. Girija M Allikatte", qualification: "M A B. Ed.", role: "Kannada Dept", image:Girija },
//   { name: "Mrs. Vaishali B Toanage", qualification: "M A B. Ed.", role: "Hindi Dept", image:Vaishali},
//   { name: "Miss. Shrutika Ghenappagol", qualification: "M. Sc. B. Ed.", role: "Science Dept", image: Shrutika },
//   { name: "Mrs. Prerana Nandani", qualification: "B. Sc. D. Ed.", role: "Maths Dept", image: Prerana },
//   { name: "Mrs. Jayashree Kanappatil", qualification: "Dip in Art", role: "Art & Craft Dept", image:Jayashree  },
//   { name: "Mr. Rahul Badiger", qualification: "M. P. Ed.", role: "Physical Instructor", image:Rahul },
//   { name: "Mrs. Ujwala Gadale", qualification: "B A D. Ed.", role: "Kannada Dept", image:Ujwala },
//   { name: "Miss. Sheetal Katkar", qualification: "B Sc. B. Ed.", role: "Maths Dept",image:Sheetal },
//   { name: "Mrs. Shilpa Magadum", qualification: "B A B. Ed.", role: "English Dept" , image:Shilpa },
//   { name: "Mrs. Sharali Shidhe", qualification: "M. A B. Ed.", role: "English Dept", image:Sharali },
//   { name: "Mrs. Sameena Shekh", qualification: "B. Com, NTC", role: "KG Section", image:Sameena },
//   { name: "Miss. Akanksha Torase", qualification: "PU NTC, D. Ed", role: "KG Section", image:Akanksha },
//   { name: "Miss. Poonam Trivedi", qualification: "BA LLB", role: "English Dept.", image:Poonam },
//   { name: "Miss Akshata Kore", qualification: "B Com.", role: "KG Section",image:Akshata },
//   { name: "Miss. Rachana Kothale", qualification: "M. A in Psychology", role: "Special Educator", image:Rachana },
//   { name: "Miss. Shrushti Anagali", qualification: "BCA NTC", role: "KG Section", image:Shrushti },
//   { name: "Miss. Divya Koli", qualification: "B Com.", role: "KG Section", image:Divya },
//   { name: "Miss. Pradnya Kuchnure", qualification: "BCA", role: "Comp Dept", image:Pradnya },
//   { name: "Miss. Shubhangi Koli", qualification: "B Com", role: "Accountant", image:Shubhangi },
//   { name: "Miss. Nikita Gane", qualification: "B. Com. NTC", role: "KG Section", image:Nikita },
//   { name: "Miss. Ankita Babannavar", qualification: "B Sc.", role: "Primary Section", image:Ankita },
//   { name: "Miss. Arpita Nandre", qualification: "B Sc. NTC", role: "KG Section", image:Arpita },
// ];


//   return (
//     <>
//       <Navbar />
//       <div className="about-container">
//         {/* Hero Section */}
//         <div className="hero-section">
//           <h1>About Our School</h1>
//           <p className="hero-subtitle">Educating minds, touching hearts since 2016</p>
//         </div>

//         {/* School Introduction */}
//         <div className="about-section">
//           <div className="about-text">
//             <h2 className="section-title">Our Story</h2>
//             <p className="highlight-text">
//               Acharya Shree Vidyanand English Medium School was established in 2016, 
//               providing education that prepares children to meet the challenges of 
//               the competitive world.
//             </p>
//             <p>
//               From humble beginnings with 40 students, we've grown five-fold and now 
//               proudly mold approximately 520 children up to grade VIII. Our school is 
//               named after Acharya Shree Vidyanand Maharaj ji, whose presence continues 
//               to inspire us to provide the best educational opportunities to our rural 
//               population.
//             </p>
//           </div>
//           <div className="about-image">
//             <img src={guruImage} alt="Acharya Shree Vidyanand Maharaj ji" className="founder-img" />
//             <div className="image-caption">Acharya Shree Vidyanand Maharaj ji</div>
//           </div>
//         </div>

//         {/* Mission, Vision, Values */}
//         <div className="mv-container">
//           <div className="mv-card mission">
//             <div className="mv-icon">🎯</div>
//             <h3>Our Mission</h3>
//             <p>
//               Provide cultural sensitivity, excellent communication skills and 
//               academic strength to our children that they become successful 
//               leaders and achievers.
//             </p>
//           </div>
          
//           <div className="mv-card vision">
//             <div className="mv-icon">🔭</div>
//             <h3>Our Vision</h3>
//             <p>
//               Establish strong connections with students so they can achieve 
//               independence, build confidence, and gain academic knowledge.
//             </p>
//           </div>
          
//           <div className="mv-card values">
//             <div className="mv-icon">❤️</div>
//             <h3>Our Values</h3>
//             <p>
//               We celebrate uniqueness, respect safety and dignity, and communicate 
//               with calmness, politeness, and civility.
//             </p>
//           </div>
//         </div>

//         {/* Key Management */}
//         <div className="section">
//           <h2 className="section-title">Key Management</h2>
//           <div className="board-list">
//             <div className="board-member">
//               <div className="member-img-container">
//                 <img src={require('../assets/assets/Picture2.png')} alt="Shri Niranjan S Narasagoudar" />
//               </div>
//               <h4>Shri. Niranjan S Narasagoudar</h4>
//               <p className="position">Chairman</p>
//               <p>ASVEM School Shedbal</p>
//             </div>
            
//             <div className="board-member">
//               <div className="member-img-container">
//                 <img src={require('../assets/assets/Picture3.png')} alt="Shri Bahubali Sidnale" />
//               </div>
//               <h4>Shri. Bahubali Sidnale</h4>
//               <p className="position">Secretary</p>
//               <p>ASVEM School, Shedbal</p>
//             </div>
            
//             <div className="board-member">
//               <div className="member-img-container">
//                 <img src={require('../assets/assets/Picture4.png')} alt="Shri Dadasaheb Patil" />
//               </div>
//               <h4>Shri. Dadasaheb Patil</h4>
//               <p className="position">Vice-Chairman</p>
//               <p>ASVEM School, Shedbal</p>
//             </div>
            
//             <div className="board-member">
//               <div className="member-img-container">
//                 <img src={require('../assets/assets/Picture5.jpg')} alt="Mrs. Paddubai S K" />
//               </div>
//               <h4>Mrs. Paddubai S K</h4>
//               <p className="position">Principal</p>
//               <p>ASVEM School, Shedbal</p>
//             </div>
//           </div>
//         </div>

//         {/* Full Board Members */}
//         <div className="section board-members-section">
//           <h2 className="section-title">Board of Management</h2>
          
//           <div className="board-banner">
//             <img src={require('../assets/assets/Picture7.png')} alt="Board of Management" />
//           </div>
          
//           <div className="board-names-container">
//             <div className="board-names-column">
//               <ul className="board-names">
//                 <li><span className="name">Shri Niranjan Narasagoudar</span> – Chairman</li>
//                 <li><span className="name">Shri Dadasaheb Patil</span> – Vice Chairman</li>
//                 <li><span className="name">Shri Bahubali Sidnale</span> – Secretary</li>
//                 <li><span className="name">Shri Shantinath Malaganve</span> – Member</li>
//                 <li><span className="name">Shri Roopesh Chougala</span> – Member</li>
//                 <li><span className="name">Shri Dhanyakumar Chougala</span> – Member</li>
//                 <li><span className="name">Shri Udaykumar Savadatti</span> – Member</li>
//               </ul>
//             </div>
            
//             <div className="board-names-column">
//               <ul className="board-names">
//                 <li><span className="name">Shri Sachin Lagare</span> – Member</li>
//                 <li><span className="name">Shri Deepak Lagare</span> – Member</li>
//                 <li><span className="name">Shri Pradeep Patil</span> – Member</li>
//                 <li><span className="name">Shri Sanjay Dargaj</span> – Member</li>
//                 <li><span className="name">Shri Sunil Iraj</span> – Member</li>
//                 <li><span className="name">Shri Praveen Patil</span> – Member</li>
//                 <li><span className="name">Shri Anandkumar Narasagoudar</span> – Member</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>



//    <div className="about-page">
//       <h2>Our Esteemed Faculty</h2>
//       <div className="faculty-list">
//         {faculties.map((faculty, index) => (
//           <div key={index} className="faculty-card">
//             <img
//               src={faculty.image}
//               alt={faculty.name}
//               className="faculty-image"
//             />
//             <h3>{faculty.name}</h3>
//             <p><strong>Qualification:</strong> {faculty.qualification}</p>
//             <p><strong>Department:</strong> {faculty.role}</p>
//           </div>
//         ))}
//       </div>
//     </div>
      
//       <Footer />

//       <style>{`

//         .about-page {
//   padding: 2rem;
//   background-color: #f9f9f9;
//   text-align: center;
// }

// .faculty-list {
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
//   gap: 1.5rem;
// }

// .faculty-card {
//   background-color: white;
//   border-radius: 12px;
//   box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//   padding: 1rem;
//   width: 250px;
//   text-align: center;
// }

// .faculty-image {
//   width: 100%;
//   height: 250px;
//   object-fit: cover;
//   border-radius: 8px;
//   margin-bottom: 1rem;
// }

// }

















//         /* Base Styles */
//         .about-container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 20px 40px;
//           font-family: 'Poppins', sans-serif;
//           color: #333;
//         }
        
//         /* Hero Section */
//         .hero-section {
//           background: linear-gradient(135deg, #0f2b6e 0%, #1a4b8c 100%);
//           color: white;
//           padding: 60px 20px;
//           text-align: center;
//           border-radius: 0 0 20px 20px;
//           margin-bottom: 40px;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.1);
//         }
        
//         .hero-section h1 {
//           font-size: 2.5rem;
//           margin-bottom: 10px;
//           font-weight: 700;
//         }
        
//         .hero-subtitle {
//           font-size: 1.2rem;
//           opacity: 0.9;
//           font-weight: 300;
//         }
        
//         /* About Section */
//         .about-section {
//           display: flex;
//           gap: 40px;
//           margin: 60px 0;
//           align-items: center;
//         }
        
//         .about-text {
//           flex: 1.5;
//         }
        
//         .about-image {
//           flex: 1;
//           position: relative;
//         }
        
//         .founder-img {
//           width: 100%;
//           border-radius: 15px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.15);
//           transition: transform 0.3s ease;
//         }
        
//         .founder-img:hover {
//           transform: scale(1.02);
//         }
        
//         .image-caption {
//           text-align: center;
//           margin-top: 10px;
//           font-style: italic;
//           color: #666;
//           font-size: 0.9rem;
//         }
        
//         .section-title {
//           color: #0f2b6e;
//           font-size: 2rem;
//           margin-bottom: 30px;
//           position: relative;
//           display: inline-block;
//         }
        
//         .section-title:after {
//           content: '';
//           position: absolute;
//           bottom: -10px;
//           left: 0;
//           width: 60px;
//           height: 4px;
//           background: #f9a826;
//           border-radius: 2px;
//         }
        
//         .highlight-text {
//           background: #f0f7ff;
//           padding: 15px;
//           border-left: 4px solid #0f2b6e;
//           font-size: 1.1rem;
//           margin-bottom: 20px;
//         }
        
//         /* Mission Vision Values */
//         .mv-container {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//           gap: 30px;
//           margin: 60px 0;
//         }
        
//         .mv-card {
//           padding: 30px;
//           border-radius: 10px;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.05);
//           transition: transform 0.3s ease, box-shadow 0.3s ease;
//           position: relative;
//           overflow: hidden;
//           z-index: 1;
//         }
        
//         .mv-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//         }
        
//         .mv-card:before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 5px;
//         }
        
//         .mission:before { background: #4a6fdc; }
//         .vision:before { background: #6c5ce7; }
//         .values:before { background: #e84393; }
        
//         .mv-card h3 {
//           color: #0f2b6e;
//           margin-top: 20px;
//           margin-bottom: 15px;
//           font-size: 1.4rem;
//         }
        
//         .mv-icon {
//           font-size: 2.5rem;
//           opacity: 0.8;
//         }
        
//         /* Board Members */
//         .board-list {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
//           gap: 30px;
//           margin-top: 40px;
//         }
        
//         .board-member {
//           background: white;
//           padding: 25px;
//           border-radius: 10px;
//           text-align: center;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.05);
//           transition: all 0.3s ease;
//         }
        
//         .board-member:hover {
//           transform: translateY(-10px);
//           box-shadow: 0 15px 30px rgba(0,0,0,0.1);
//         }
        
//         .member-img-container {
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           overflow: hidden;
//           margin: 0 auto 20px;
//           border: 5px solid #f0f7ff;
//         }
        
//         .member-img-container img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }
        
//         .board-member h4 {
//           color: #0f2b6e;
//           margin: 10px 0 5px;
//           font-size: 1.2rem;
//         }
        
//         .position {
//           color: #f9a826;
//           font-weight: 600;
//           margin-bottom: 5px;
//         }
        
//         /* Full Board Members */
//         .board-members-section {
//           margin-top: 80px;
//           background: #f9fafc;
//           padding: 40px;
//           border-radius: 15px;
//         }
        
//         .board-banner {
//           margin: 30px 0;
//           text-align: center;
//         }
        
//         .board-banner img {
//           max-width: 100%;
//           border-radius: 10px;
//           box-shadow: 0 5px 20px rgba(0,0,0,0.1);
//         }
        
//         .board-names-container {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 40px;
//           justify-content: center;
//           margin-top: 30px;
//         }
        
//         .board-names-column {
//           flex: 1;
//           min-width: 300px;
//         }
        
//         .board-names {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//         }
        
//         .board-names li {
//           padding: 12px 0;
//           border-bottom: 1px solid #eee;
//           font-size: 1rem;
//           position: relative;
//           padding-left: 25px;
//         }
        
//         .board-names li:before {
//           content: '';
//           position: absolute;
//           left: 0;
//           top: 18px;
//           width: 10px;
//           height: 10px;
//           background: #0f2b6e;
//           border-radius: 50%;
//         }
        
//         .name {
//           font-weight: 600;
//           color: #0f2b6e;
//         }
        
//         /* Responsive Adjustments */
//         @media (max-width: 768px) {
//           .about-section {
//             flex-direction: column;
//           }
          
//           .hero-section h1 {
//             font-size: 2rem;
//           }
          
//           .section-title {
//             font-size: 1.8rem;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default AboutUs;





























import React from "react";
import guruImage from "../assets/assets/Picture1.jpg";
import Navbar from "./Header";
import Footer from "./Footer";
import sukhadev from "../assets/assets/sukhadev.png";
import pooja from "../assets/assets/pooja.jpg";
import Girija from "../assets/assets/Girija.jpg";
import Vaishali from "../assets/assets/Vaishali.jpg";
import Shrutika from "../assets/assets/Shrutika.jpg";
import Prerana from "../assets/assets/Prerana.jpg";
import Jayashree from "../assets/assets/Jayashree.jpg";
import Rahul from "../assets/assets/Rahul.jpg";
import Ujwala from "../assets/assets/Ujwala.jpg";
import Sheetal from "../assets/assets/Sheetal.jpg";
import Shilpa from "../assets/assets/Shilpa.jpg";
import Sharali from "../assets/assets/Sharali.jpg";
import Sameena from "../assets/assets/Sameena.jpg";
import Akanksha from "../assets/assets/Akanksha.jpg";
import Poonam from "../assets/assets/Poonam.jpg";
import Akshata from "../assets/assets/Akshata.jpg";
import Rachana from "../assets/assets/Rachana.jpg";
import Shrushti from "../assets/assets/Shrushti.jpg";
import Divya from "../assets/assets/Divya.jpg";
import Pradnya from "../assets/assets/Pradnya.jpg";
import Shubhangi from "../assets/assets/Shubhangi.jpg";
import Nikita from "../assets/assets/Nikita.jpg";
import Ankita from "../assets/assets/Ankita.jpg";
import Arpita from "../assets/assets/Arpita.jpg";

const AboutUs = () => {
  const faculties = [
    { name: "Mr. Sukhadev S Koli", qualification: "DSCE, BCA, MCSE", role: "Manager & IT Head", image: sukhadev },
    { name: "Miss. Pooja S Kore", qualification: "B. Sc. B. Ed.", role: "Science Dept", image: pooja },
    { name: "Miss. Girija M Allikatte", qualification: "M A B. Ed.", role: "Kannada Dept", image: Girija },
    { name: "Mrs. Vaishali B Toanage", qualification: "M A B. Ed.", role: "Hindi Dept", image: Vaishali },
    { name: "Miss. Shrutika Ghenappagol", qualification: "M. Sc. B. Ed.", role: "Science Dept", image: Shrutika },
    { name: "Mrs. Prerana Nandani", qualification: "B. Sc. D. Ed.", role: "Maths Dept", image: Prerana },
    { name: "Mrs. Jayashree Kanappatil", qualification: "Dip in Art", role: "Art & Craft Dept", image: Jayashree },
    { name: "Mr. Rahul Badiger", qualification: "M. P. Ed.", role: "Physical Instructor", image: Rahul },
    { name: "Mrs. Ujwala Gadale", qualification: "B A D. Ed.", role: "Kannada Dept", image: Ujwala },
    { name: "Miss. Sheetal Katkar", qualification: "B Sc. B. Ed.", role: "Maths Dept", image: Sheetal },
    { name: "Mrs. Shilpa Magadum", qualification: "B A B. Ed.", role: "English Dept", image: Shilpa },
    { name: "Mrs. Sharali Shidhe", qualification: "M. A B. Ed.", role: "English Dept", image: Sharali },
    { name: "Mrs. Sameena Shekh", qualification: "B. Com, NTC", role: "KG Section", image: Sameena },
    { name: "Miss. Akanksha Torase", qualification: "PU NTC, D. Ed", role: "KG Section", image: Akanksha },
    { name: "Miss. Poonam Trivedi", qualification: "BA LLB", role: "English Dept.", image: Poonam },
    { name: "Miss Akshata Kore", qualification: "B Com.", role: "KG Section", image: Akshata },
    { name: "Miss. Rachana Kothale", qualification: "M. A in Psychology", role: "Special Educator", image: Rachana },
    { name: "Miss. Shrushti Anagali", qualification: "BCA NTC", role: "KG Section", image: Shrushti },
    { name: "Miss. Divya Koli", qualification: "B Com.", role: "KG Section", image: Divya },
    { name: "Miss. Pradnya Kuchnure", qualification: "BCA", role: "Comp Dept", image: Pradnya },
    { name: "Miss. Shubhangi Koli", qualification: "B Com", role: "Accountant", image: Shubhangi },
    { name: "Miss. Nikita Gane", qualification: "B. Com. NTC", role: "KG Section", image: Nikita },
    { name: "Miss. Ankita Babannavar", qualification: "B Sc.", role: "Primary Section", image: Ankita },
    { name: "Miss. Arpita Nandre", qualification: "B Sc. NTC", role: "KG Section", image: Arpita },
  ];

  return (
    <>
      <Navbar />
      
      {/* Hero Section with Parallax Effect */}
      <div className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">About Our School</h1>
          <p className="hero-subtitle">Educating minds, touching hearts since 2016</p>
          <div className="scroll-indicator">
            <span></span>
          </div>
        </div>
      </div>

      <div className="about-container">
        {/* School Introduction */}
        <section className="about-section">
          <div className="about-text">
            <h2 className="section-title">
              <span className="title-decorator"></span>
              Our Story
            </h2>
            <p className="highlight-text">
              Acharya Shree Vidyanand English Medium School was established in 2016, 
              providing education that prepares children to meet the challenges of 
              the competitive world.
            </p>
            <p>
              From humble beginnings with 40 students, we've grown five-fold and now 
              proudly mold approximately 520 children up to grade VIII. Our school is 
              named after Acharya Shree Vidyanand Maharaj ji, whose presence continues 
              to inspire us to provide the best educational opportunities to our rural 
              population.
            </p>
          </div>
          <div className="about-image">
            <div className="image-frame">
              <img 
                src={guruImage} 
                alt="Acharya Shree Vidyanand Maharaj ji" 
                className="founder-img" 
              />
            </div>
            <div className="image-caption">Acharya Shree Vidyanand Maharaj ji</div>
          </div>
        </section>

        {/* Mission, Vision, Values */}
        <section className="mv-section">
          <h2 className="section-title">
            <span className="title-decorator"></span>
            Our Core Principles
          </h2>
          <div className="mv-container">
            <div className="mv-card mission">
              <div className="mv-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"/>
                </svg>
              </div>
              <h3>Our Mission</h3>
              <p>
                Provide cultural sensitivity, excellent communication skills and 
                academic strength to our children that they become successful 
                leaders and achievers.
              </p>
            </div>
            
            <div className="mv-card vision">
              <div className="mv-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                </svg>
              </div>
              <h3>Our Vision</h3>
              <p>
                Establish strong connections with students so they can achieve 
                independence, build confidence, and gain academic knowledge.
              </p>
            </div>
            
            <div className="mv-card values">
              <div className="mv-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                </svg>
              </div>
              <h3>Our Values</h3>
              <p>
                We celebrate uniqueness, respect safety and dignity, and communicate 
                with calmness, politeness, and civility.
              </p>
            </div>
          </div>
        </section>

        

        {/* Key Management */}

      </div>
      
      <Footer />

      <style>{`
        /* Base Styles */
        :root {
          --primary-color: #0f2b6e;
          --secondary-color: #f9a826;
          --accent-color: #4a6fdc;
          --light-bg: #f9fafc;
          --dark-text: #333;
          --light-text: #fff;
          --card-shadow: 0 10px 30px rgba(0,0,0,0.1);
          --transition: all 0.3s ease;
        }
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        body {
          font-family: 'Poppins', sans-serif;
          color: var(--dark-text);
          line-height: 1.6;
          overflow-x: hidden;
        }
        
        /* Hero Section */
        .hero-section {
          height: 80vh;
          min-height: 500px;
          background: linear-gradient(rgba(15, 43, 110, 0.8), rgba(15, 43, 110, 0.9)), 
                      url('../assets/assets/school-bg.jpg') center/cover no-repeat;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          position: relative;
          overflow: hidden;
          margin-bottom: 60px;
        }
        
        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle at center, transparent 0%, rgba(15, 43, 110, 0.9) 100%);
        }
        
        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          padding: 0 20px;
          color: var(--light-text);
          animation: fadeInUp 1s ease;
        }
        
        .hero-title {
          font-size: 3.5rem;
          font-weight: 700;
          margin-bottom: 20px;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }
        
        .hero-subtitle {
          font-size: 1.5rem;
          font-weight: 300;
          margin-bottom: 40px;
          opacity: 0.9;
        }
        
        .scroll-indicator {
          margin-top: 50px;
          animation: bounce 2s infinite;
        }
        
        .scroll-indicator span {
          display: block;
          width: 30px;
          height: 50px;
          border: 2px solid var(--light-text);
          border-radius: 15px;
          margin: 0 auto;
          position: relative;
        }
        
        .scroll-indicator span:before {
          content: '';
          position: absolute;
          top: 8px;
          left: 50%;
          width: 6px;
          height: 6px;
          background: var(--light-text);
          border-radius: 50%;
          transform: translateX(-50%);
          animation: scrollDown 2s infinite;
        }
        
        /* About Container */
        .about-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px 80px;
        }
        
        /* Section Titles */
        .section-title {
          font-size: 2.2rem;
          color: var(--primary-color);
          margin-bottom: 40px;
          position: relative;
          display: inline-block;
          padding-left: 20px;
        }
        
        .title-decorator {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 8px;
          height: 40px;
          background: var(--secondary-color);
          border-radius: 4px;
        }
        
        /* About Section */
        .about-section {
          display: flex;
          gap: 60px;
          margin: 80px 0;
          align-items: center;
        }
        
        .about-text {
          flex: 1.5;
          animation: fadeInLeft 1s ease;
        }
        
        .about-image {
          flex: 1;
          position: relative;
          animation: fadeInRight 1s ease;
        }
        
        .image-frame {
          position: relative;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: var(--card-shadow);
          transition: var(--transition);
        }
        
        .image-frame:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(15,43,110,0.3) 0%, rgba(249,168,38,0.1) 100%);
          z-index: 1;
        }
        
        .founder-img {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 0.5s ease;
        }
        
        .image-frame:hover .founder-img {
          transform: scale(1.05);
        }
        
        .image-caption {
          text-align: center;
          margin-top: 15px;
          font-style: italic;
          color: #666;
          font-size: 0.9rem;
        }
        
        .highlight-text {
          background: rgba(15, 43, 110, 0.05);
          padding: 20px;
          border-left: 4px solid var(--primary-color);
          font-size: 1.1rem;
          margin-bottom: 25px;
          border-radius: 0 8px 8px 0;
        }
        
        /* Mission Vision Values */
        .mv-section {
          margin: 100px 0;
        }
        
        .mv-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 40px;
          margin-top: 50px;
        }
        
        .mv-card {
          padding: 40px 30px;
          border-radius: 12px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          transition: var(--transition);
          position: relative;
          overflow: hidden;
          z-index: 1;
          background: var(--light-bg);
          text-align: center;
        }
        
        .mv-card:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 5px;
        }
        
        .mission:before { background: var(--accent-color); }
        .vision:before { background: #6c5ce7; }
        .values:before { background: #e84393; }
        
        .mv-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.1);
        }
        
        .mv-card h3 {
          color: var(--primary-color);
          margin: 25px 0 15px;
          font-size: 1.5rem;
        }
        
        .mv-icon {
          width: 70px;
          height: 70px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(74, 111, 220, 0.1);
          border-radius: 50%;
        }
        
        .mv-icon svg {
          width: 32px;
          height: 32px;
          fill: var(--accent-color);
        }
        
        .vision .mv-icon {
          background: rgba(108, 92, 231, 0.1);
        }
        
        .vision .mv-icon svg {
          fill: #6c5ce7;
        }
        
        .values .mv-icon {
          background: rgba(232, 67, 147, 0.1);
        }
        
        .values .mv-icon svg {
          fill: #e84393;
        }
        
        /* Board Members */
        .management-section {
          margin: 100px 0;
        }
        
        .board-list {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 40px;
          margin-top: 50px;
        }
        
        .board-member {
          background: white;
          padding: 30px;
          border-radius: 12px;
          text-align: center;
          box-shadow: var(--card-shadow);
          transition: var(--transition);
          position: relative;
          overflow: hidden;
        }
        
        .board-member:hover {
          transform: translateY(-10px);
        }
        
        .member-img-container {
          width: 150px;
          height: 150px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 25px;
          position: relative;
        }
        
        .img-border {
          position: absolute;
          top: -5px;
          left: -5px;
          right: -5px;
          bottom: -5px;
          border: 2px solid var(--secondary-color);
          border-radius: 50%;
          z-index: 1;
          animation: rotate 8s linear infinite;
        }
        
        .member-img-container img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
        
        .board-member h4 {
          color: var(--primary-color);
          margin: 15px 0 5px;
          font-size: 1.3rem;
        }
        
        .position {
          color: var(--secondary-color);
          font-weight: 600;
          margin-bottom: 5px;
          font-size: 1rem;
        }
        
        /* Full Board Members */
        .board-section {
          margin: 100px 0;
          background: var(--light-bg);
          padding: 60px 40px;
          border-radius: 20px;
          position: relative;
          overflow: hidden;
        }
        
        .board-section:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 5px;
          background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
        }
        
        .board-banner {
          margin: 50px 0;
          text-align: center;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: var(--card-shadow);
        }
        
        .board-banner img {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 0.5s ease;
        }
        
        .board-banner:hover img {
          transform: scale(1.02);
        }
        
        .board-names-container {
          display: flex;
          flex-wrap: wrap;
          gap: 60px;
          justify-content: center;
          margin-top: 40px;
        }
        
        .board-names-column {
          flex: 1;
          min-width: 300px;
        }
        
        .board-names {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .board-names li {
          padding: 15px 0;
          border-bottom: 1px solid #eee;
          font-size: 1.05rem;
          position: relative;
          padding-left: 30px;
          transition: var(--transition);
        }
        
        .board-names li:hover {
          transform: translateX(5px);
        }
        
        .board-names li:before {
          content: '';
          position: absolute;
          left: 0;
          top: 22px;
          width: 12px;
          height: 12px;
          background: var(--secondary-color);
          border-radius: 50%;
        }
        
        .name {
          font-weight: 600;
          color: var(--primary-color);
        }
        
        /* Faculty Section */
        .faculty-section {
          margin: 100px 0;
        }
        
        .faculty-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 30px;
          margin-top: 50px;
        }
        
        .faculty-card {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: var(--card-shadow);
          transition: var(--transition);
        }
        
        .faculty-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.15);
        }
        
        .faculty-img-container {
          position: relative;
          height: 250px;
          overflow: hidden;
        }
        
        .faculty-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        .faculty-overlay {
          position: absolute;
          bottom: -100%;
          left: 0;
          width: 100%;
          padding: 20px;
          background: rgba(15, 43, 110, 0.9);
          color: white;
          transition: bottom 0.3s ease;
        }
        
        .faculty-card:hover .faculty-overlay {
          bottom: 0;
        }
        
        .faculty-info {
          padding: 20px;
          text-align: center;
        }
        
        .faculty-info h3 {
          color: var(--primary-color);
          margin-bottom: 5px;
          font-size: 1.2rem;
        }
        
        .department {
          color: var(--secondary-color);
          font-weight: 500;
          font-size: 0.9rem;
        }
        
        /* Animations */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-20px);
          }
          60% {
            transform: translateY(-10px);
          }
        }
        
        @keyframes scrollDown {
          0% {
            opacity: 1;
            transform: translate(-50%, 0);
          }
          100% {
            opacity: 0;
            transform: translate(-50%, 15px);
          }
        }
        
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        
        /* Responsive Adjustments */
        @media (max-width: 992px) {
          .hero-title {
            font-size: 2.8rem;
          }
          
          .about-section {
            flex-direction: column;
          }
          
          .about-image {
            order: -1;
            margin-bottom: 40px;
            max-width: 500px;
          }
        }
        
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.2rem;
          }
          
          .hero-subtitle {
            font-size: 1.2rem;
          }
          
          .section-title {
            font-size: 1.8rem;
          }
          
          .mv-container {
            grid-template-columns: 1fr;
          }
          
          .board-names-column {
            min-width: 100%;
          }
        }
        
        @media (max-width: 576px) {
          .hero-title {
            font-size: 1.8rem;
          }
          
          .board-section {
            padding: 40px 20px;
          }
          
          .faculty-grid {
            grid-template-columns: 1fr;
          }
        }


        /* Desk Messages */
.desk-messages-container {
  display: flex;
  flex-direction: column;
  gap: 60px;
  margin-bottom: 80px;
}

.desk-message {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--card-shadow);
  transition: var(--transition);
  padding: 30px;
}

.desk-message:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
}

.message-header {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 30px;
}

.message-title h3 {
  color: var(--primary-color);
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.message-title h4 {
  color: var(--dark-text);
  font-size: 1.2rem;
  margin-bottom: 5px;
}

.message-title .position {
  color: var(--secondary-color);
  font-weight: 600;
  font-size: 0.9rem;
}

.message-content {
  color: #555;
  line-height: 1.8;
}

.message-content p {
  margin-bottom: 15px;
}

.message-signature {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  font-style: italic;
}

.message-signature p {
  margin-bottom: 5px;
}

/* Responsive adjustments for desk messages */
@media (max-width: 768px) {
  .message-header {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .message-title h3 {
    font-size: 1.3rem;
  }
  
  .message-title h4 {
    font-size: 1.1rem;
  }
}
      `}</style>
    </>
  );
};

export default AboutUs;